export const SET_PROCESSES_LIST = 'SET_PROCESSES_LIST';
export const SET_FILTERS_DATA_PROCESS = 'SET_FILTERS_DATA_PROCESS';
export const SET_PROCESS = 'SET_PROCESS';
export const SET_NAME_IN_LIST = 'SET_NAME_IN_LIST';
export const SET_TYPES_PROCESS = 'SET_TYPES_PROCESS';
export const SET_FILTERS_CREATORS = 'SET_FILTERS_CREATORS';
